// export const REQUEST_URL = 'http://47.114.100.230:81'
export const REQUEST_URL = 'https://p.pian-ai.com/zw-gateway/app'
// export const REQUEST_URL = 'https://p.pian-ai.com/zw-gateway-test/app'
